import './form.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';
import isEmpty from 'lodash/isEmpty';

import Input from '../../../shared/form-elements/input';

const Form = ({
	handleSubmit,
	submitForm,
	data,
	intl,
	deletePayouts,
	can
}) => {
	return (
		<div className="form-container campaign-payouts-form">
			<div className="form-container__head">
				<h2>{ intl('Edit specific campaign payout') }</h2>
			</div>

			<div className="form-container__body">
				<div className="campaign-payouts-form">
					<table className="campaign-payouts-table">
						<thead className="simple-table__head font-roboto-medium">
							<th>sid</th>
							<th>amount</th>
							<th>currency</th>
							<th>action</th>
						</thead>
						<tbody>
							{
								data.map((item, index) =>
									<tr key={index}>
										<td>{item.sid}{!!item.sid_type && ` (${item.sid_type})`}</td><td>{item.amount}</td>
										<td>{item.currency}</td>
										<td>
											<button className="ui-btn" onClick={() => deletePayouts(item.sid, item.sid_type)}>
												delete
											</button>
										</td>
									</tr>
								)
							}
						</tbody>

					</table>
				</div>
				<form className="ui-form create-cpl-rule display-flex" onSubmit={handleSubmit(data => submitForm(data))}>

					<div className="ui-form__element margin-0-10">
						<Field
							name="campaign_id"
							placeholder={intl('Campaign_id')}
							disabled={true}
							component={Input}
						/>
					</div>

					<div className="ui-form__element margin-0-10">
						<Field
							name="sid"
							placeholder={intl('sid (can be sid1, sid2, sid3, sid4 or sid5)')}
							component={Input}
						/>
					</div>

					<div className="ui-form__element margin-0-10">
						<Field
							name="amount"
							placeholder={intl('payout')}
							component={Input}
						/>
					</div>

					<div className="ui-form__element margin-0-10">
						<Field
							name="currency"
							placeholder={intl('Currency')}
							disabled={true}
							component={Input}
						/>
					</div>
					<div className="ui-form__element buttons">
						{can('campaignsEdit') &&
							<button className="ui-btn ui-btn-primary">
								{intl('Save')}
							</button>}
						{<Link to="campaigns/">
							<button type="button" className="ui-btn ui-btn-cancel">
								{intl('Cancel')}
							</button>
						</Link>}
					</div>
				</form>
			</div>
		</div>
	);
};

const requiredFields = ['geo_id', 'rub_payout', 'usd_payout'];

const validate = values => {
	const errors = {};

	requiredFields.forEach((field) => {
		if (isEmpty(values[field])) {
			errors[field] = 'required';
		}
	});

	return errors;
};

export default reduxForm({
	form: 'campaignsPayoutEdit',
	validate
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaigns/payout-editor/components/form.js